import { Alert, Form, FormInstance, Input } from 'antd';
import React from 'react';
import { urlValidator } from './onboarding-logic';

const { TextArea } = Input;

interface CampaignInfoFormProps {
  form: FormInstance;
}

export const CampaignInfoForm: React.FC<CampaignInfoFormProps> = ({ form }) => {
  const privacyUrl = Form.useWatch(
    ['campaign_info', 'privacy_policy_url'],
    form,
  );
  const termsUrl = Form.useWatch(['campaign_info', 'terms_url'], form);
  const sameUrl = privacyUrl && termsUrl && privacyUrl === termsUrl;

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Form.Item
          label="Client Website"
          name={['campaign_info', 'client_website']}
          rules={[
            { required: true, message: 'Client website is required' },
            { validator: urlValidator },
          ]}
        >
          <Input placeholder="https://www.example.com" />
        </Form.Item>

        <Form.Item
          label="Form URL"
          name={['campaign_info', 'form_url']}
          rules={[
            { required: true, message: 'Form URL is required' },
            { validator: urlValidator },
          ]}
        >
          <Input placeholder="https://www.example.com/page" />
        </Form.Item>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Form.Item
          label="Form Button Text"
          name={['campaign_info', 'form_button_text']}
          rules={[{ required: true, message: 'Form button text is required' }]}
        >
          <Input placeholder="I'm interested" />
        </Form.Item>

        <Form.Item
          label="Listing URL"
          name={['campaign_info', 'listing_url']}
          rules={[
            { required: true, message: 'Listing URL is required' },
            { validator: urlValidator },
          ]}
        >
          <Input placeholder="https://www.example.com/page" />
        </Form.Item>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Form.Item
          label="Privacy Policy URL"
          name={['campaign_info', 'privacy_policy_url']}
          rules={[
            { required: true, message: 'Privacy policy URL is required' },
            { validator: urlValidator },
          ]}
        >
          <Input placeholder="https://www.example.com/privacy-policy" />
        </Form.Item>

        <Form.Item
          label="Terms of Service URL"
          name={['campaign_info', 'terms_url']}
          rules={[
            { required: true, message: 'Terms URL is required' },
            { validator: urlValidator },
          ]}
        >
          <Input placeholder="https://www.example.com/terms-of-service" />
        </Form.Item>
      </div>

      {sameUrl && (
        <Alert
          message="Privacy Policy and Terms of Service point to the same URL. Verify the document covers both."
          showIcon
          style={{ marginBottom: 16 }}
          type="info"
        />
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Form.Item
          label="Assistant Name"
          name={['campaign_info', 'assistant_name']}
          rules={[{ required: true, message: 'Assistant name is required' }]}
        >
          <Input placeholder="Alex" />
        </Form.Item>

        <Form.Item
          label="Team Name"
          name={['campaign_info', 'team_name']}
          rules={[{ required: true, message: 'Team name is required' }]}
        >
          <Input placeholder="e.g. Acme Real Estate" />
        </Form.Item>
      </div>

      <Form.Item
        label="Area Code"
        name="area_code"
        rules={[
          { required: true, message: 'Area code is required' },
          { pattern: /^\d{3}$/, message: 'Must be a 3-digit area code' },
        ]}
      >
        <Input placeholder="e.g. 305" style={{ maxWidth: 120 }} />
      </Form.Item>

      <Form.Item
        label="Disclosure Text"
        name={['campaign_info', 'disclosure_text']}
        tooltip="Paste the actual disclosure text from the client's website form. If left empty, a default will be used."
      >
        <TextArea
          placeholder="By providing your cellular telephone number, you are consenting to allow..."
          rows={4}
        />
      </Form.Item>
    </>
  );
};
